import { FormattedMessage } from "react-intl";
import { memo } from "react";

import { Badge } from "common/core/badge";

const MatchesIdentity = memo(
  ({ matchesIdentity, withBadge = true }: { matchesIdentity?: boolean; withBadge?: boolean }) => {
    if (matchesIdentity === undefined) {
      return <>--</>;
    }

    const content = matchesIdentity ? (
      <FormattedMessage id="40dbe29f-a3fa-4835-9010-9fc79e2a94f3" defaultMessage="Yes" />
    ) : (
      <FormattedMessage id="20c143d2-d4c5-496c-a29a-4a4967be78da" defaultMessage="No" />
    );

    return withBadge ? (
      <Badge kind={matchesIdentity ? "success" : "warning"}>{content}</Badge>
    ) : (
      content
    );
  },
);

export default MatchesIdentity;
